import React, { useState } from "react";
import "./index.scss";
import { Button, Divider, TextField } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Select from "react-select";

const StoreContacts = () => {
  const [value, setValue] = useState([null, null]);
  const [data, setData] = useState([
    {
      store: 70116,
      satellite: 0,
      storeStatus: "Open & Operating",
      faStatus: "Active",
      currentOwner: "Yes",
      primContact: "Yes",
      locatedIn: "SCF-Bela Chowk",
      streetPOBox: "Bela Chowk",
      address1: "",
      city: "RupNagar",
      county: "",
      stateProv: "Punjab",
      postalCode: 140001,
      country: "INDIA",
    },
    {
      store: 70116,
      satellite: 0,
      storeStatus: "Open & Operating",
      faStatus: "Active",
      currentOwner: "Yes",
      primContact: "Yes",
      locatedIn: "SCF-Bela Chowk",
      streetPOBox: "Bela Chowk",
      address1: "sf",
      city: "RupNagar",
      county: "sdf",
      stateProv: "Punjab",
      postalCode: 140001,
      country: "INDIA",
    },
  ]);

  return (
    <div className="store-memos-container">
      <div className="search-container">
        <TextField placeholder="Store" />
        <Select placeholder="Satellite" classNamePrefix="custom_select" />
        <Button variant="contained" size="small">
          Get Data
        </Button>
      </div>
      <Divider />
      <div className="memo-list-container">
        <span>Development Agent / Master Franchise Contact Assignments </span>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }}>
            <TableHead sx={{ backgroundColor: "#008a52", color: "white" }}>
              <TableRow>
                <TableCell className="table-cell">Contact JOB</TableCell>
                <TableCell className="table-cell">
                  Business Phone Number
                </TableCell>
                <TableCell className="table-cell">Name</TableCell>
                <TableCell className="table-cell">Email</TableCell>
                <TableCell className="table-cell">Voice Mail</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((ele) => (
                <TableRow key={ele.store}>
                  <TableCell>{ele.store}</TableCell>
                  <TableCell>{ele.satellite}</TableCell>
                  <TableCell>{ele.storeStatus}</TableCell>
                  <TableCell>{ele.storeStatus}</TableCell>
                  <TableCell>{ele.storeStatus}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
      <div
        style={{
          padding: 20,
        }}
      >
        <Divider />
      </div>

      <div className="memo-list-container">
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }}>
            <TableHead sx={{ backgroundColor: "#008a52", color: "white" }}>
              <TableRow>
                <TableCell className="table-cell">Use DA/MF</TableCell>
                <TableCell className="table-cell">Contact Job</TableCell>
                <TableCell className="table-cell">Name</TableCell>
                <TableCell className="table-cell">
                  Business Phone number
                </TableCell>
                <TableCell className="table-cell">EMail</TableCell>
                <TableCell className="table-cell">Voice Mail</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((ele) => (
                <TableRow key={ele.store}>
                  <TableCell>{ele.store}</TableCell>
                  <TableCell>{ele.satellite}</TableCell>
                  <TableCell>{ele.storeStatus}</TableCell>
                  <TableCell>{ele.storeStatus}</TableCell>
                  <TableCell>{ele.storeStatus}</TableCell>
                  <TableCell>{ele.storeStatus}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </div>
  );
};
export default StoreContacts;
